module.exports = __webpack_public_path__ + "img/currencyDetails4.55d65119.png";